import React from 'react';
import { createArray } from '../_utils';
var WorkFlowSchematicSkeleton = function () { return (React.createElement("div", { className: "workflow row" }, createArray(4).map(function (i) { return (React.createElement("div", { key: i, className: "col-3 px-0" },
    React.createElement("span", { className: "skeleton-line skeleton-h-lg w-50" }),
    React.createElement("span", { className: "skeleton-line skeleton-h-lg w-100" }),
    React.createElement("span", { className: "skeleton-line skeleton-h-lg w-50" }))); }))); };
export default React.memo(WorkFlowSchematicSkeleton);
